import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from './services/config.service';
import { TranslationService } from './shared/services/translation.service';
import { LoaderComponent } from './shared/components/loader';
import { LoaderService } from './shared/services/loader.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  title = 'Healthcare Management System';
  // private configService = inject(ConfigService);
  private translationService = inject(TranslationService);
  loaderService = inject(LoaderService);

  ngOnInit(): void {
    // Initialize config and theme on app startup
    // this.configService.loadConfig().subscribe();
    
    // Initialize translation service
    this.translationService.init();
  }
}
